import { COOKIE_AGE, DOMAIN } from '@/constants/app';
import is from './is';

const findCookie = (name: string, cookieString: string) =>
  cookieString
    .split('; ')
    .find((cookie) => cookie.startsWith(`${name}=`))
    ?.split('=')?.[1];

export const getCookieString = (
  name: string,
  value: string,
  validity = COOKIE_AGE,
  sameSite = 'Strict',
  domain = DOMAIN,
  path = '/',
) => {
  if (!name || !value) return '';
  return `${name}=${value}; Max-Age=${validity}; Path=${path}; Domain=.${domain};`; //  SameSite=${sameSite};
};

class Cookies {
  static get = (name: string, serverCookie?: string) => {
    if (is.client()) {
      return findCookie(name, document.cookie);
    } else if (serverCookie) {
      return findCookie(name, serverCookie);
    }
    return undefined;
  };

  static set = (name: string, value: string, expiryInDays: number = 1, path?: string) => {
    if (name && value) {
      let cookieString = `${name}=${value};`;
      if (expiryInDays) {
        const date = new Date();
        date.setTime(date.getTime() + expiryInDays * 24 * 60 * 60 * 1000);
        cookieString += `expires=${date.toUTCString()};`;
      }
      cookieString += `path=${path ?? '/'};  domain=.${DOMAIN};`; // sameSite=Strict;
      document.cookie = cookieString;
      return true;
    }
    return false;
  };

  static has = (name: string, serverCookie?: string) => {
    return Boolean(this.get(name, serverCookie));
  };

  static delete = (name: string) => {
    if (this.has(name)) {
      document.cookie =
        name + `=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=.${DOMAIN};`;
      return true;
    }
    return false;
  };
}

export default Cookies;
